import React from 'react';
import styles from './CaseStudyHeroSection.module.css';
import { IoChevronForward } from 'react-icons/io5';
import Button from '../../Button/Button';
import { useTranslation } from '../../../hooks/useTranslation';

interface CaseStudyTab {
    id: string;
    title: React.ReactNode;
}

interface CaseStudyHeroSectionProps {
    tabs: CaseStudyTab[];
    activeTabId: string;
    onTabChange: (tabId: string) => void;
}

const CaseStudyHeroSection: React.FC<CaseStudyHeroSectionProps> = ({
    tabs,
    activeTabId,
    onTabChange,
}) => {
    const { t } = useTranslation();
    
    return (
        <section className={styles.heroSection}>
            <div className={styles.container}>
                <h1 className={styles.title}>
                    {t("caseStudies.hero.title")}
                </h1>
                <p className={styles.subtitle}>
                    {t("caseStudies.hero.subtitle")}
                </p>
                <div className={styles.tabsContainer}>
                    <div className={styles.tabs}>
                        {tabs.map((tab) => (
                            <Button
                                variant="text-underline"
                                key={tab.id}
                                className={`${styles.tab} ${activeTabId === tab.id ? styles.activeTab : ''}`}
                                onClick={() => onTabChange(tab.id)}
                            >
                                {tab.title}
                            </Button>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default CaseStudyHeroSection; 